import type { State, ViewStyle } from "./types";
import React, { useEffect } from "react";
import { Dispatch, SetStateAction } from "react";
import { TbListSearch } from "react-icons/tb";
import { cn } from "../../../utils/cn";
import Loading from "./Loading";

import { TfiLayoutGrid3, TfiLayoutGrid2 } from "react-icons/tfi";

interface Props {
    state: State;
    setState: Dispatch<SetStateAction<State>>;
}

const defaultViewStyle: ViewStyle = "threeColumns";

const Component = ({ state, setState }: Props) => {
    // Cargamos la vista guardada en localStorage y si vemos
    // algo raro ponemos el estilo predeterminado
    useEffect(() => {
        const savedViewStyle = localStorage.getItem("viewStyle");

        if (
            savedViewStyle &&
            (savedViewStyle === "twoColumns" || savedViewStyle === "threeColumns")
        ) {
            setState(prevState => ({
                ...prevState,
                viewStyle: savedViewStyle as ViewStyle,
            }));
        } else {
            setState(prevState => ({
                ...prevState,
                viewStyle: defaultViewStyle,
            }));
        }
    }, [setState]);

    const viewStyle = state.viewStyle;

    const handleClick = (viewStyle: ViewStyle) => {
        setState(prevState => {
            const newState = { ...prevState, viewStyle };
            localStorage.setItem("viewStyle", viewStyle);
            return newState;
        });
    };

    return (
        <div className={styles.container}>
            <Loading loading={state.loading} />

            <SearchInput state={state} setState={setState} />

            <div className={styles.buttonsContainer}>
                <button
                    title="Cambiar a vista de columnas"
                    className={cn(
                        "rounded-l",
                        styles.defaultViewListButton,
                        viewStyle === "twoColumns" && styles.activeViewListButton,
                    )}
                    onClick={() => handleClick("twoColumns")}
                >
                    <TfiLayoutGrid2 className="w-5 h-5" />
                </button>

                <button
                    title="Cambiar a vista de cuadrícula"
                    className={cn(
                        "rounded-r",
                        styles.defaultViewListButton,
                        viewStyle === "threeColumns" && styles.activeViewListButton,
                    )}
                    onClick={() => handleClick("threeColumns")}
                >
                    <TfiLayoutGrid3 className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
};

const SearchInput = ({ state, setState }: Props) => {
    return (
        <div className="w-full relative flex flex-col gap-5 flex-shrink">
            <div className="relative text-gray-500 focus-within:text-gray-900 ">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <TbListSearch className="w-5 h-5 ml-1" />
                </div>

                <input
                    type="text"
                    className={styles.searchInput}
                    placeholder="Filtrar por texto"
                    value={state.textFilter || ""}
                    onChange={e => {
                        const value = e.target.value;
                        setState(prevState => ({
                            ...prevState,
                            textFilter: value,
                        }));
                    }}
                />
            </div>
        </div>
    );
};

const styles = {
    container: "flex flex-row items-center md:justify-between gap-3 md:gap-5",
    searchInput:
        "block w-full pr-4 pl-12 py-2 text-sm font-normal shadow-xs text-gray-900 bg-transparent border border-gray-300 rounded placeholder-gray-400 focus:outline-none leading-relaxed",
    buttonsContainer: "flex justify-center text-gray-500",
    defaultViewListButton:
        "py-2 px-4 inline-flex justify-center items-center gap-2 -ml-px ml-0 border font-medium bg-white align-middle focus:z-10 focus:outline-none text-sm hover:bg-ccyan hover:text-white hover:border-ccyan duration-300",
    activeViewListButton: "bg-ccyan text-white border-ccyan",
};

export default Component;
